export enum PageEnum {
  /**
   * 登录页面
   */
  BASE_LOGIN = '/login',
  BASE_LOGIN_NAME = 'Login',
  /**
   * 重定向页面
   */
  REDIRECT = '/redirect',
  REDIRECT_NAME = 'Redirect',
  /**
   * 首页
   */
  BASE_HOME = '/home/index',
  /**
   * 首页跳转默认路由
   */
  BASE_HOME_REDIRECT = '/home/index',
  /**
   * 错误页面
   */
  ERROR_PAGE_NAME = 'ErrorPage',
}
